import { useSearchParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { GoogleLogo, ShieldStar, ArrowLeft } from '@phosphor-icons/react';
import { useAuth } from '@/context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const error = params.get('error');

  useEffect(() => {
    if (!loading && user) navigate('/admin/inquiries', { replace: true });
  }, [user, loading, navigate]);

  const handleGoogle = () => {
    const redirectUrl = window.location.origin + '/admin/inquiries';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0A1128] text-white relative overflow-hidden flex items-center justify-center px-6">
      <div className="absolute inset-0 bg-grid-lines opacity-50 pointer-events-none" />

      <div className="relative w-full max-w-md">
        <button
          data-testid="admin-login-back"
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-[#94A3B8] hover:text-white transition-colors mb-8"
        >
          <ArrowLeft size={14} weight="bold" />
          Back to site
        </button>

        <div className="bg-[#151F32]/80 backdrop-blur-md border border-white/10 p-8 md:p-10">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 flex items-center justify-center border border-white/15 bg-white/5 text-[#4F6355]">
              <ShieldStar size={20} weight="duotone" />
            </span>
            <div>
              <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#94A3B8]">
                CDPA / Admin
              </div>
              <div className="font-display font-bold text-white text-lg tracking-tight">
                Restricted access
              </div>
            </div>
          </div>

          <h1 className="font-display font-bold tracking-tighter mt-8 text-3xl text-white leading-tight">
            Sign in to view inquiries
          </h1>
          <p className="mt-3 text-sm text-[#94A3B8] leading-relaxed">
            Only allowlisted Google accounts can access the admin dashboard. Sign in with the email
            authorized by CDPA SYSTEMS CONCEPT.
          </p>

          {error && (
            <div
              data-testid="admin-login-error"
              className="mt-6 px-4 py-3 border border-red-400/30 bg-red-900/20 text-red-200 text-sm"
            >
              {error}
            </div>
          )}

          <button
            data-testid="admin-login-google"
            onClick={handleGoogle}
            className="btn-primary mt-8 w-full inline-flex items-center justify-center gap-3 px-6 py-4 text-[12px] tracking-[0.22em] uppercase font-bold"
          >
            <GoogleLogo size={18} weight="bold" />
            Continue with Google
          </button>

          <div className="mt-8 pt-6 border-t border-white/10 font-mono text-[10px] tracking-[0.3em] uppercase text-[#94A3B8]">
            Secured channel · CDPA SYSTEMS CONCEPT
          </div>
        </div>
      </div>
    </div>
  );
}
